import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { SectionHeader, BookCard, Badge } from "@/components/site/primitives";
import { fadeUp, stagger } from "@/lib/motion";
import { bookHref } from "@/lib/bookModel";
import { resolveMockBookId } from "@/components/bookDetails/utils/resolveMockBookId";
import { RECOMMENDED } from "@/data";

export default function RecommendedForYou() {
  return (
    <section className="u-container mt-14 md:mt-20" data-testid="home-recommended">
      <SectionHeader eyebrow="Picked for your taste" title="Recommended for You" />
      <motion.div variants={stagger} initial="hidden" animate="show" className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
        {RECOMMENDED.map((book, i) => (
          <motion.div key={book.title} variants={fadeUp} custom={i} className="flex flex-col gap-2">
            <Link to={bookHref(resolveMockBookId(book))} state={{ hint: book }}>
              <BookCard {...book} />
            </Link>
            <Badge tone={book.tone} className="w-fit">{book.genre}</Badge>
            {book.reason && <p className="text-xs italic text-subtle">{book.reason}</p>}
          </motion.div>
        ))}
      </motion.div>
    </section>
  );
}
